import type { ShapeAnnotation } from "@modules/docs/annotations/types/TAnnotation";
import type { BackendAnnotationRecord } from "@modules/docs/annotations/types/TBackendAnnotation";

export function fromBackendRecord(record: BackendAnnotationRecord): ShapeAnnotation {
  return {
    id: record.id,
    type: "shape",
    kind: record.kind,
    color: record.color,
    source: "backend",
    areas: (record.areas ?? []).map((a) => ({ page: a.page, position: a.geom })),
    notes: record.notes ?? [],
  };
}

export function fromBackendRecords(records: BackendAnnotationRecord[]): ShapeAnnotation[] {
  return (records ?? []).map(fromBackendRecord);
}
